export default {"src":"/_next/static/media/roadmap-tick.c61a7fc7.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};